import Modal from "@/components/modal/modal.vue";
import { MyGoalService } from "@/services/myGoalsApi";

// eslint-disable-next-line complexity
const validateProps = (structure) => (value) => {
	for (const key in structure) {
		const { required, validator } = structure[key];

		if (!(key in value)) {
			if (required) return false;

			continue;
		}

		if (validator && !validator(value[key])) return false;
	}

	return true;
};

export default {
	components: { Modal },

	props: {
		data: {
			type: Object,
			required: true,
			validator: validateProps({
				monthlyGoal: { required: true },
				baselineWeight: { required: true },
				label: {
					required: false,
					validator: validateProps({
						labelId: { required: true },
						description: { required: true },
						translations: { required: true },
						baselineDates: { required: true },
					}),
				},
			}),
		},
		showWPG: { type: Boolean, required: true },
	},

	data() {
		return {
			percentage: this.data.monthlyGoal,
			submitted: false,
		};
	},

	methods: {
		close,
		submit,
	},

	computed: { newGoalValue },
};

function newGoalValue() {
	const PERCENTAGE = 100;

	return (1 - this.percentage / PERCENTAGE) * this.data.baselineWeight;
}

// eslint-disable-next-line complexity
async function submit() {
	this.submitted = true;

	try {
		const PERCENTAGE = 100;

		if (this.data.label) {
			await MyGoalService.setItemGoal({
				labelId: this.data.label.labelId,
				percentage: this.percentage / PERCENTAGE,
			});
		} else {
			await MyGoalService.setMonthlyGoal({
				month: this.$moment(Date.now()).format("YYYY-MM-DD"),
				percentage: this.percentage / PERCENTAGE,
			});
		}

		this.$ma.trackEvent({
			action: "Monthly goal set",
			properties: {
				Value: (this.data.label ? this.data.label.description_name : "Outlet ") + "goal : " + this.percentage,
				Component: this.$route.name,
			},
		});

		this.$emit("close", true);
	} catch (error) {
		this.submitted = false;
		this.$swal({
			text: error.message,
			customClass: "swal_modal",
		});
	}
}

function close() {
	this.$emit("close");
}
